import { Footer2021, Header2021, use2021Page } from './shared';
import { awardCategories2021, winners2021 } from './data';

const Portfolio2021 = () => {
  const { lang } = use2021Page('Smart Living Partnership Awards 2021 - Portfolio');
  const params = new URLSearchParams(window.location.search);
  const award = params.get('award') || 'arts';
  const winner = params.get('winner') || 'digitOasis';
  const category = awardCategories2021.find((c) => c.key === award);
  const winnerItem = (winners2021[award]?.[lang] || []).find((w) => w.id === winner);
  return (
    <>
      <Header2021 lang={lang} currentPath="portfolio" />
      <main>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/awards.png)', marginTop: '7.5%', marginLeft: '-3px' }}>
          <img src="/2021/images/awards.png" style={{ visibility: 'hidden' }} alt="" />
        </div>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/portfolio.png)', marginTop: '-5px', marginBottom: '-5px' }}>
          <img src="/2021/images/portfolio.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <div className="dtalks portfolio" style={{ marginTop: 50 }}>
              <div className="container">
                <div className="row" style={{ display: 'flex' }}>
                  <div className="wrapper" style={{ width: '20%', margin: '20px 0' }}>
                    <span className="card"><img style={{ visibility: 'visible' }} src={`/2021/images/${award}.png`} alt="" /><div className="whitebg"></div></span>
                  </div>
                  <div className="wrapper" style={{ width: '80%', margin: '25px 70px' }}>
                    <p style={{ backgroundColor: '#e5fde7', width: 'fit-content' }}>{lang === 'zh' ? '公司名稱' : 'Company Name'}</p>
                    <h1 style={{ width: '90%' }}>{winnerItem?.awardee || winner}</h1>
                    <p>{lang === 'zh' ? '得獎類別' : 'Award Category'} | <b>{lang === 'zh' ? category?.zh : category?.en}</b></p>
                    <h3>{lang === 'zh' ? '獎項' : 'Award'}</h3>
                    <h2>{winnerItem?.award_name || ''}</h2>
                  </div>
                </div>
                <div style={{ margin: '0 20%' }}>
                  <h2 style={{ textAlign: 'center' }}>{lang === 'zh' ? '得獎項目圖片' : 'Highlight'}</h2>
                  <div style={{ width: '80%', boxShadow: '12px 12px 2px 1px rgb(8, 48, 80)' }}>
                    <img style={{ visibility: 'visible' }} src={`/2021/images/portfolio/${award}/${winner}.JPG`} alt={winner} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer2021 lang={lang} />
    </>
  );
};

export default Portfolio2021;
